// ============================================================================
// Spacing Viz Active Context — Provides gated spacing-viz state to renderer blocks.
//
// The raw hookstate (spacingVizState.ts) defaults to `true`, but renderer blocks
// should only show spacing overlays when BOTH the global toggle is on AND we're in
// editor preview mode. ComposableSection gates this and provides the result via
// this context. Public CMS pages never set previewMode, so blocks get `false`.
// ============================================================================

import { createContext, useContext } from 'react';

const SpacingVizActiveContext = createContext<boolean>(false);

export const SpacingVizActiveProvider = SpacingVizActiveContext.Provider;

/**
 * Returns `true` only when spacing visualization should render.
 * Safe for both editor preview and public pages.
 */
export function useSpacingVizActive(): boolean {
  return useContext(SpacingVizActiveContext);
}
